import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { defaultTheme } from 'styles/themes/default';
import GlobalSytle from './styles/global';
import AppProvider from './hooks';
import Routes from './routes';

const App: React.FC = () => (
  <Router>
    <ThemeProvider theme={defaultTheme}>
      <AppProvider>
        <Routes />
      </AppProvider>
      <GlobalSytle />
    </ThemeProvider>
  </Router>
);

export default App;
